import React from "react";
import moment from "moment";
import { Modal } from "seed/helpers"
import l from "components/util/l";
import Chat from "components/presentation/chat/Chat";

const NotificationsView = ({
  flow = {},
  notifications = [],
  selectedChat,
  setSelectedChat,
  onClickResume,
}) => (
  <div className="px-1">
    <div className="">

      {
        notifications.map((notification, index) => {

          const { execution, amount, isAwaiting, isAsync } = notification;
          const { firstStep = {} } = execution;
          const { flowNode = {} } = firstStep;
          const { rootName } = flowNode;

          return <div
            key={`notification-${execution.id}`}
            class={`notification-item d-flex justify-content-between align-items-center w-100 rounded p-2` 
                + (index == notifications.length - 1 ? "" : " border-bottom mb-1")
            }
          >
            <div className="d-flex align-items-center w-100 justify-content-between">
              <div className="d-flex align-items-center w-100 text-truncate">
                
                {
                  isAwaiting &&
                    <i className="fas fa-hourglass-half fa-lg text-warning mr-3" />
                }

                {
                  isAsync &&
                    <i className="fas fa-bell fa-lg text-primary mr-3" />
                }

                <div className="d-flex flex-column w-100 text-truncate">
                  <span className="text-truncate mt-1 mb-0 text-wrap mr-3">
                    {
                      isAwaiting &&
                        <>
                          {l("El proceso%VD006","Aa")} <strong>{rootName}</strong> {l("necesita atención%VD015","Aa")}
                        </>
                    }
                    {
                      isAsync &&
                        <>
                          {l("Se%GA014","Aa")} {amount == 1 ? l("ha%GA015","Aa") : l("han%GA016","Aa")} {l("completado%GA017","aa")} {amount == 1 ? l("un%GA018","Aa") : amount} <strong>{rootName}</strong>
                        </>
                    }
                  </span>
                  <small>
                    {moment(notification.execution.updatedAt).format("DD.MMM / HH:mm")}
                  </small>
                </div>

                {
                  isAwaiting &&
                    <button
                      type="button"
                      className="chat-history-item-button btn btn-sm btn-outline-primary ml-1"
                      onClick={() => onClickResume(execution)}
                    >
                      <i className="fas fa-arrow-right mr-1" />
                    </button>
                }

              </div>
            </div>
          </div>

        })
      }

      {
        notifications.length == 0 &&
          <div id="no-flows-content" className="d-flex align-items-center justify-content-center mt-1 py-3">
            <i className="fas fa-bell-slash fa-lg text-muted mr-2" />
            <h6 className="text-muted mt-1">
              {l("No tienes notificaciones pendientes%VD008","Aa")}
            </h6>
          </div>
      }

      {
        selectedChat &&
          <Modal
            width={800}
            onClose={() => setSelectedChat(null)}
          >
            <div id="chat-studio-container" className="card h-100">
              <div className="card-body p-1 h-100">
                <Chat
                  flow={flow}
                  chat={selectedChat}
                  currentChat={selectedChat}
                  isExecutionChat={true}
                />
              </div>
            </div>
          </Modal>
      }

    </div>
  </div>
)

export default NotificationsView;